export const productForm = [
  {
    name: "name",
    label: "Product Name",
    type: "text",
    placeholder: "Enter name",
  },
  {
    name: "sku",
    label: "SKU",
    type: "text",
    placeholder: "Enter SKU",
  },
  {
    name: "clientPrice",
    label: "Client Price",
    type: "number",
    placeholder: "Enter price",
  },
  {
    name: "costPrice",
    label: "Cost Price",
    type: "number",
    placeholder: "Enter price",
  },
  {
    name: "ourSiteUrl",
    label: "Source Product URL",
    type: "text",
    placeholder: "Enter URL of product's source page",
  },
  {
    name: "urls",
    label: "URL",
    type: "dynamic",
    placeholder: "Enter URL",
  },
];
